'use client';

import { ReactNode } from 'react';

import { useCompleteRegistrationGuard } from '@/app/(main)/_hooks/use-complete-registration-guard.hook';

export function CompleteRegistrationGuard({ children }: { children: ReactNode }) {
  useCompleteRegistrationGuard();

  return <>{children}</>;
}
